import React, { useState, useContext } from 'react';
import * as Styled from './TableSection.styled';
import RichText from '../RichText/RichText';
import { TableSectionFragment } from './TableSection.gql';
import { ContainerQueryContext } from '../../../../util/ContainerQuery.context';
/**
 * TableSection component is used to display content system configured tables.
 */
var TableSection = function (_a) {
    var tableContent = _a.tableContent;
    var hasTableTabs = tableContent.length > 1;
    var _b = useState(0), currentSelection = _b[0], setCurrentSelection = _b[1];
    var styleQueryMode = useContext(ContainerQueryContext).styleQueryMode;
    return (React.createElement(Styled.TableSection, { "$styleQueryMode": styleQueryMode },
        React.createElement(Styled.TableContent, null,
            hasTableTabs && (React.createElement(Styled.SelectSlide, { name: "tableSelector", onChange: function (event) { return setCurrentSelection(event.currentTarget.value); }, selectedOption: currentSelection.toString() }, tableContent.map(function (group, i) { return (React.createElement(Styled.SelectSlide.Option, { key: i, label: group.label, value: i.toString() })); }))),
            React.createElement(RichText, { richText: tableContent[currentSelection].content, config: { header: 3 } }))));
};
TableSection.fragment = TableSectionFragment;
export default TableSection;
